// IEEE 14-bus standard power grid model in PSSE 'raw file' format
import ieee14RawData from './ieee14bus.raw';

export const IEEE_14_BUS_RAW_DATA = ieee14RawData;
